import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  EMPTY, Observable, from, of, throwError, take,
  catchError, delay, retry, switchMap
} from 'rxjs';

import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class HttpInterceptor {

  private authenticationService = inject(AuthenticationService);


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const user = this.authenticationService.user();
    if (!user) { return next.handle(request); }

    return from(this.authenticationService.getIdToken()).pipe(
      take(1),
      switchMap(token => {
        const headers = request.headers
          .set('Authorization', `Bearer ${token}`)
          .set('Accept', 'application/json')
          .set('Content-Type', 'application/json')
          .set('version', '1');

        return next.handle(request.clone({ headers, withCredentials: true })).pipe(

          catchError((error: HttpErrorResponse) => {
              if (error.status === 401 && !request.headers.has('x-token-refreshed')) {
                  this.handle401Error(error);
                  return from(this.authenticationService.getIdToken(true)).pipe(
                      take(1),
                      switchMap(fresh => {
                          const hdrs = headers
                              .set('Authorization', `Bearer ${fresh}`)
                              .set('x-token-refreshed', '1');
                          return next.handle(request.clone({ headers: hdrs, withCredentials: true }));
                        })
                    );
                }

            // Log other errors
            console.log('Error:', error);
            return throwError(() => error);
          }),
          retry({
            count: 3, // Number of retry attempts
            delay: (error, retryCount) => {
              const delayDuration = retryCount * 1000; // 1 second multiplied by the retry count
              return of(error).pipe(delay(delayDuration)); // Add a delay before retrying
            }
          }),
          catchError((error: HttpErrorResponse) => {
            // Handle critical errors after retries are exhausted
            this.handleCriticalError(error);
            return throwError(() => error);
          })
        );
      })
    );
  }

  private handleCriticalError(error: HttpErrorResponse) {
    console.error('Critical error after retries:', error.message);
  }

  private handle401Error(error: HttpErrorResponse) {
    console.error('401 error:', error.message);
  }

}
